import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/raptor/program/clusterdev/desh-web-editor/app/(routes)/apk/components/Footer/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/raptor/program/clusterdev/desh-web-editor/app/(routes)/apk/components/Header/style.module.css");
;
import(/* webpackMode: "eager" */ "/home/raptor/program/clusterdev/desh-web-editor/app/(routes)/apk/components/Subfooter/style.module.css");
;
import(/* webpackMode: "eager" */ "/home/raptor/program/clusterdev/desh-web-editor/app/(routes)/apk/style.module.css");
;
import(/* webpackMode: "eager" */ "/home/raptor/program/clusterdev/desh-web-editor/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/raptor/program/clusterdev/desh-web-editor/node_modules/next/dist/client/link.js");
